import { ReactNode } from "react";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { Result, Button } from "antd";
import { resolveRouteRule, userHasModuleAccess } from "./routeModuleMap";

interface Props {
  children: ReactNode;
}

function ModuleGuard({ children }: Props) {
  const location = useLocation();
  const user = useSelector((state: any) => state.User?.user);

  // location.pathname under /Auth/* starts with /Auth; strip it so rules work
  const rel = location.pathname.replace(/^\/Auth/, "") || "/";
  const rule = resolveRouteRule(rel);

  if (!rule) return <>{children}</>;

  if (!userHasModuleAccess(user, rule)) {
    return (
      <Result
        status="403"
        title="Access Denied"
        subTitle="You do not have permission to view this module."
        extra={
          <Button type="primary" href="/Auth">
            Back to Dashboard
          </Button>
        }
      />
    );
  }

  return <>{children}</>;
}

export default ModuleGuard;
